import {
	ActivateProductionMaterialEventMutation,
	ActivateProductionSpaceEventMutation,
	ActivateProductionTaskEventMutation,
	AddProductionMaterialEventDetailsMutation,
	AddProductionSpaceEventDetailsMutation,
	AddProductionTaskEventDetailsMutation,
	ClearTaskEventDirectCostMutation,
	ClearTaskEventLaborTypeTagMutation,
	ClearTaskEventThroughputMutation,
	CreateProductionMaterialEventMutation,
	CreateProductionSpaceEventMutation,
	CreateProductionTaskEventMutation,
	DeleteProductionMaterialEventMutation,
	DeleteProductionSpaceEventMutation,
	DeleteProductionTaskEventMutation,
	InactivateProductionMaterialEventMutation,
	InactivateProductionSpaceEventMutation,
	InactivateProductionTaskEventMutation,
	RemoveProductionMaterialEventDetailMutation,
	RemoveProductionSpaceEventDetailMutation,
	RemoveProductionTaskEventDetailMutation,
	SetTaskEventDetailThroughputMutation,
	SetTaskEventDirectCostMutation,
	SetTaskEventLaborTypeTagMutation,
	SetTaskEventThroughputMutation,
	UpdateProductionMaterialEventDetailMutation,
	UpdateProductionMaterialEventMutation,
	UpdateProductionSpaceEventDetailMutation,
	UpdateProductionSpaceEventMutation,
	UpdateProductionTaskEventDetailMutation,
	UpdateProductionTaskEventMutation
} from "~/gql/mutations/produce/productionEventsManagement.generated";
import {
	GetProductionMaterialEventDetailsByEventsQuery,
	GetProductionMaterialEventDetailsQuery,
	GetProductionMaterialEventQuery,
	GetProductionMaterialEventsQuery,
	GetProductionSpaceEventDetailsQuery,
	GetProductionSpaceEventQuery,
	GetProductionSpaceEventsQuery,
	GetProductionTaskEventDetailsQuery,
	GetProductionTaskEventQuery,
	GetProductionTaskEventsQuery,
	GetTaskEventCostsQuery
} from "~/gql/queries/produce/productionEventsManagement.generated";

export const eventsManagementEndpoints = {
	ActivateProductionMaterialEvent: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: ActivateProductionMaterialEventMutation) => res
	},
	ActivateProductionSpaceEvent: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ActivateProductionSpaceEventMutation) => res
	},
	ActivateProductionTaskEvent: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: ActivateProductionTaskEventMutation) => res
	},
	AddProductionMaterialEventDetails: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: AddProductionMaterialEventDetailsMutation) => res
	},
	AddProductionSpaceEventDetails: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: AddProductionSpaceEventDetailsMutation) => res
	},
	AddProductionTaskEventDetails: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: AddProductionTaskEventDetailsMutation) => res
	},
	CreateProductionMaterialEvent: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: CreateProductionMaterialEventMutation) => res
	},
	CreateProductionSpaceEvent: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: CreateProductionSpaceEventMutation) => res
	},
	CreateProductionTaskEvent: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: CreateProductionTaskEventMutation) => res
	},
	DeleteProductionMaterialEvent: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: DeleteProductionMaterialEventMutation) => res
	},
	DeleteProductionSpaceEvent: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: DeleteProductionSpaceEventMutation) => res
	},
	DeleteProductionTaskEvent: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: DeleteProductionTaskEventMutation) => res
	},
	GetProductionMaterialEvent: {
		providesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionMaterialEventQuery) => res
	},
	GetProductionMaterialEventDetails: {
		providesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionMaterialEventDetailsQuery) => res
	},
	GetProductionMaterialEventDetailsByEvents: {
		providesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionMaterialEventDetailsByEventsQuery) => res
	},
	GetProductionMaterialEvents: {
		providesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionMaterialEventsQuery) => res
	},
	GetProductionSpaceEvent: {
		providesTags: ["ProductionSpaceEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceEventQuery) => res
	},
	GetProductionSpaceEventDetails: {
		providesTags: ["ProductionSpaceEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceEventDetailsQuery) => res
	},
	GetProductionSpaceEvents: {
		providesTags: ["ProductionSpaceEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceEventsQuery) => res
	},
	GetProductionTaskEvent: {
		providesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionTaskEventQuery) => res
	},
	GetProductionTaskEventDetails: {
		providesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionTaskEventDetailsQuery) => res
	},
	GetProductionTaskEvents: {
		providesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: GetProductionTaskEventsQuery) => res
	},
	GetTaskEventCosts: {
		providesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: GetTaskEventCostsQuery) => res
	},
	InactivateProductionMaterialEvent: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: InactivateProductionMaterialEventMutation) => res
	},
	InactivateProductionSpaceEvent: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: InactivateProductionSpaceEventMutation) => res
	},
	InactivateProductionTaskEvent: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: InactivateProductionTaskEventMutation) => res
	},
	RemoveProductionMaterialEventDetail: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: RemoveProductionMaterialEventDetailMutation) => res
	},
	RemoveProductionSpaceEventDetail: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: RemoveProductionSpaceEventDetailMutation) => res
	},
	RemoveProductionTaskEventDetail: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: RemoveProductionTaskEventDetailMutation) => res
	},
	ClearTaskEventThroughput: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: ClearTaskEventThroughputMutation) => res
	},
	ClearTaskEventDirectCost: {
		invalidatesTags: ["ProductionTaskEvents", "ProductionRecipe"] as AddTagTypes,
		transformResponse: (res: ClearTaskEventDirectCostMutation) => res
	},
	ClearTaskEventLaborTypeTag: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: ClearTaskEventLaborTypeTagMutation) => res
	},
	SetTaskEventLaborTypeTag: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: SetTaskEventLaborTypeTagMutation) => res
	},
	SetTaskEventThroughput: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: SetTaskEventThroughputMutation) => res
	},
	SetTaskEventDetailThroughput: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: SetTaskEventDetailThroughputMutation) => res
	},
	SetTaskEventDirectCost: {
		invalidatesTags: ["ProductionTaskEvents", "ProductionRecipe"] as AddTagTypes,
		transformResponse: (res: SetTaskEventDirectCostMutation) => res
	},
	UpdateProductionMaterialEvent: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: UpdateProductionMaterialEventMutation) => res
	},
	UpdateProductionMaterialEventDetail: {
		invalidatesTags: ["ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: UpdateProductionMaterialEventDetailMutation) => res
	},
	UpdateProductionSpaceEvent: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: UpdateProductionSpaceEventMutation) => res
	},
	UpdateProductionSpaceEventDetail: {
		invalidatesTags: ["ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: UpdateProductionSpaceEventDetailMutation) => res
	},
	UpdateProductionTaskEvent: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: UpdateProductionTaskEventMutation) => res
	},
	UpdateProductionTaskEventDetail: {
		invalidatesTags: ["ProductionTaskEvents"] as AddTagTypes,
		transformResponse: (res: UpdateProductionTaskEventDetailMutation) => res
	}
};
